import PropTypes from "prop-types";
import React from "react";
import { ImEye, ImEyeBlocked } from "react-icons/im";

export default function PasswordIcon({ textConfig, onClick, size }) {
  return textConfig.type === "password" ? (
    <ImEye data-testid="imgEye" onClick={() => onClick(textConfig)} size={size} />
  ) : (
    <ImEyeBlocked data-testid="imgEyeBlocked" onClick={() => onClick(textConfig)} size={size} />
  );
}

PasswordIcon.propTypes = {
  textConfig: PropTypes.object,
  onClick: PropTypes.func,
  size: PropTypes.string,
};

PasswordIcon.defaultProps = {
  textConfig: null,
  onClick: null,
  size: null,
};
